import { VStack, Divider, Body, Box } from '@hover/blueprint';
import React from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { ILink } from '../../../interfaces/ILink';

interface Props {
  links: ILink[];
  currentSection: string;
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const CareersFloatingLinks: React.FC<Props> = ({
  links,
  currentSection,
  setCurrentSection,
}) => (
  <Box
    d={{ base: 'none', desktop: 'flex' }}
    position="sticky"
    top="30vh"
    left="50px"
    flexDir="column"
    w="100px"
    justifyContent="center"
    zIndex={1}
    transform="auto"
    mt={97}
    mb={97}
  >
    <Divider color="neutral.300" my={100} />
    <VStack height="240px" divider={<Divider color="neutral.300" />}>
      {links.map(link => (
        <AnchorLink
          to={`${process.env.GATSBY_V2_PREFIX}/careers${link.to}`}
          stripHash
          key={link.to}
          onAnchorLinkClick={() => setCurrentSection(link.label)}
        >
          <Body
            lineHeight={200}
            cursor="pointer"
            color={currentSection === link.label ? 'primary.500' : 'black'}
            my={200}
            textAlign="left"
            size={500}
            key={link.label}
            isSemiBold
          >
            {link.label}
          </Body>
        </AnchorLink>
      ))}
    </VStack>
    <Divider color="neutral.300" mt={400} />
  </Box>
);

export default CareersFloatingLinks;
